/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecRiskForm990ScheduleA } from './ExecRiskForm990ScheduleA';
import {
    ExecRiskForm990ScheduleAFromJSON,
    ExecRiskForm990ScheduleAFromJSONTyped,
    ExecRiskForm990ScheduleAToJSON,
} from './ExecRiskForm990ScheduleA';
import type { ExecRiskForm990ScheduleR } from './ExecRiskForm990ScheduleR';
import {
    ExecRiskForm990ScheduleRFromJSON,
    ExecRiskForm990ScheduleRFromJSONTyped,
    ExecRiskForm990ScheduleRToJSON,
} from './ExecRiskForm990ScheduleR';
import type { ExecRiskIRS990 } from './ExecRiskIRS990';
import {
    ExecRiskIRS990FromJSON,
    ExecRiskIRS990FromJSONTyped,
    ExecRiskIRS990ToJSON,
} from './ExecRiskIRS990';
import type { ExecRiskIRS990EZ } from './ExecRiskIRS990EZ';
import {
    ExecRiskIRS990EZFromJSON,
    ExecRiskIRS990EZFromJSONTyped,
    ExecRiskIRS990EZToJSON,
} from './ExecRiskIRS990EZ';

/**
 * 
 * @export
 * @interface ExecRiskReturnData
 */
export interface ExecRiskReturnData {
    /**
     * 
     * @type {ExecRiskIRS990}
     * @memberof ExecRiskReturnData
     */
    IRS990?: ExecRiskIRS990;
    /**
     * 
     * @type {ExecRiskIRS990EZ}
     * @memberof ExecRiskReturnData
     */
    IRS990EZ?: ExecRiskIRS990EZ;
    /**
     * 
     * @type {ExecRiskForm990ScheduleA}
     * @memberof ExecRiskReturnData
     */
    IRS990ScheduleA?: ExecRiskForm990ScheduleA;
    /**
     * 
     * @type {ExecRiskForm990ScheduleR}
     * @memberof ExecRiskReturnData
     */
    IRS990ScheduleR?: ExecRiskForm990ScheduleR;
}

/**
 * Check if a given object implements the ExecRiskReturnData interface.
 */
export function instanceOfExecRiskReturnData(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskReturnDataFromJSON(json: any): ExecRiskReturnData {
    return ExecRiskReturnDataFromJSONTyped(json, false);
}

export function ExecRiskReturnDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskReturnData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'IRS990': !exists(json, 'IRS990') ? undefined : ExecRiskIRS990FromJSON(json['IRS990']),
        'IRS990EZ': !exists(json, 'IRS990EZ') ? undefined : ExecRiskIRS990EZFromJSON(json['IRS990EZ']),
        'IRS990ScheduleA': !exists(json, 'IRS990ScheduleA') ? undefined : ExecRiskForm990ScheduleAFromJSON(json['IRS990ScheduleA']),
        'IRS990ScheduleR': !exists(json, 'IRS990ScheduleR') ? undefined : ExecRiskForm990ScheduleRFromJSON(json['IRS990ScheduleR']),
    };
}

export function ExecRiskReturnDataToJSON(value?: ExecRiskReturnData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'IRS990': ExecRiskIRS990ToJSON(value.IRS990),
        'IRS990EZ': ExecRiskIRS990EZToJSON(value.IRS990EZ),
        'IRS990ScheduleA': ExecRiskForm990ScheduleAToJSON(value.IRS990ScheduleA),
        'IRS990ScheduleR': ExecRiskForm990ScheduleRToJSON(value.IRS990ScheduleR),
    };
}

